editCarrouselElementButtonController.$inject = ['$scope', '$mdDialog', '$translate', 'QuickRepliesFactory', 'elementData', 'elementView',];
export function editCarrouselElementButtonController($scope, $mdDialog, $translate, QuickRepliesFactory, elementData, elementView) {
  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.initTypeDropdownItems = initTypeDropdownItems;
  $scope.onTypeChange = onTypeChange;
  $scope.isButtonUrlValid = isButtonUrlValid;

  init();

  function init() {
    $scope.elementData = elementData;
    $scope.elementView = elementView.getParentView();
    $scope.mustCheckButtonValidity = elementView.getParentView().getConfigurationOption('carrousel-must-check-button-validity');

    initTypeDropdownItems()
  }

  function ok() {
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function initTypeDropdownItems() {
    $scope.typeDropdownItems = [{
      id: 'postback',
      label: $translate.instant(elementView.resolveTranslationKey('edit_carrousel_element_button_type_postback'))
    }, {
      id: 'url',
      label: $translate.instant(elementView.resolveTranslationKey('edit_carrousel_element_button_type_url'))
    }];
  }

  function onTypeChange() {
    resetElementData();
  }

  function resetElementData() {
    elementData.url = undefined;
    elementData.phone_number = undefined;
  }

  function isButtonUrlValid() {
    if (elementData.type === 'url') {
      return QuickRepliesFactory.isLineUrlValid(elementData.url)
    }
    return true;
  }

}
